import React, { useEffect, useState } from 'react'
import ImageCarousel from '../common-Components/ImageCarousel'
import axios from 'axios'
import { useAuth } from './auth/AuthProvider'
import { useParams } from 'react-router-dom'
import { API_BASE_URL, getBearerToken } from '../../functions'
import { Col, Row } from 'react-bootstrap'

const DashBtnDetails = () => {
    const [data, setData] = useState('')
    const [loading, setLoading] = useState(false)
    const dashbtnid = useParams()
    const { token } = useAuth();
    const [currentPage, setCurrentPage] = useState(1);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])


    useEffect(() => {
        setLoading(true)
        axios.get(`${API_BASE_URL}/banners-list?page=${currentPage}`, {
            headers: {
                'Authorization': `Bearer ${getBearerToken()}`,
                'Dash-Btn-Id': String(dashbtnid?.id || '')
            }
        }).then(response => {
            // Handle the response data
            if (currentPage === 1) {
                setData(response?.data?.data?.data)
            } else {
                setData(preData => [...preData, ...response?.data?.data?.data]);
            }
            setLoading(false)
        }).catch(error => {
            // Handle errors
            console.error(error);
            setLoading(false)
        });
    }, [])

    console.log(dashbtnid);

    return (
        <Row className="my-4 justify-content-center">
            <Col className="mb-4" xxl={8} xl={8} lg={8} md={8}>
                <ImageCarousel data={data} />
            </Col>
        </Row>
    )
}

export default DashBtnDetails